import { getAuth } from 'quartz-core/framework/auth/app';
import { Provider } from 'react-redux';
import { DataFetchingClient, DataFetchingClientProvider } from 'data-fetching-client';
// @ts-expect-error Library not migrated yet
import { FeedbackLoaderProvider } from 'feedback-loader/FeedbackLoaderProvider';
import { configureStore } from './app/utils/configureStore';
import { initializeAuth } from './app/actions/AppActions';
import { startApp } from './app/actions/AppActions';
import { Routes } from './app/components/Routes';
import { SlowRolloutAPI } from './app/data/SlowRollout';
import { jsx as _jsx } from "react/jsx-runtime";
export const prepareApp = async () => {
  const client = new DataFetchingClient();
  const store = configureStore();
  const auth = getAuth();
  const isOptedIn = await SlowRolloutAPI.fetchIsOptedIn();
  store.dispatch(initializeAuth(Object.assign({}, auth, {
    portal: Object.assign({}, auth.portal, {
      isSlowRollout: isOptedIn
    })
  })));
  store.dispatch(startApp());
  return {
    props: {
      store,
      client
    }
  };
};
export function AppComponent({
  store,
  client
}) {
  return /*#__PURE__*/_jsx(DataFetchingClientProvider, {
    client: client,
    children: /*#__PURE__*/_jsx(FeedbackLoaderProvider, {
      children: /*#__PURE__*/_jsx(Provider, {
        store: store,
        children: /*#__PURE__*/_jsx(Routes, {})
      })
    })
  });
}